module.exports = __webpack_public_path__ + "img/user-profile.1c4de8de.png";